<template>
<a-locale-provider :locale="locale">
<div>
    
    <br/>
    
    <br/>
    <br/>
    <div :style="{ borderBottom: '1px solid #E9E9E9' }">
             <h3>设备列表</h3>
             
    </div>
    <div>
       <a-table :rowSelection="rowSelection" :columns="columns" :dataSource="result" >
         <span slot="onlineStatus" slot-scope="text, record">
           <span v-if="record.onlineStatus == 0">离线</span>
           <span v-if="record.onlineStatus == 1">在线</span>
        </span>
       </a-table><br/>
        <a-row>
            <a-col a-col span="24"  align="right">
                <a-button type="primary" @click="addDevice()" style="margin-right: 5vw">同步设备</a-button>
                <a-modal title="提示" v-model="visible" @ok="handleOk" locale={locale}>
                  <p>同步完成，点击确定关闭页面</p>
                </a-modal>
            </a-col>
        </a-row>
    </div>
</div>
</a-locale-provider>
    
</template>


<style scoped>


</style>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const columns = [
        {
            title:'序号',
            customRender:(text,record,index)=>`${index+1}`,
            width:60
        },
        {
            title: '设备名称',
            dataIndex: 'name',
            key: 'name',
            width: 120,
        },
        {
            title: '设备sn',
            key: 'sn',
            dataIndex: 'sn',
            width: 100,
            scopedSlots: { customRender: 'sn' },
            className: 'col-package'
        },
         {
            title: '是否在线',
            dataIndex: 'onlineStatus',
            width:100,
            key: 'onlineStatus',
            scopedSlots: { customRender: 'onlineStatus' },
        },
        
        
 ];



export default {
  data() {
    return {
      locale: zhCN,
      columns,
      result:[],
      selectArray:[],
      selectList:"",
      selectedRowKeys: [], 
      visible:false,
      pagination: {
                // 默认当前页，每页显示数量，总数
                current: 1, 
                pageSize: 20,
                total: 0,
                showSizeChanger: true, //可改变每页数量
                pageSizeOptions: ['20', '50', '100'],
                showTotal: total => `共 ${total} 条`,
                onChange: (current, pageSize) => this.pageChange(current, pageSize),
                onShowSizeChange: (current, pageSize) => this.pageSizeChange(current, pageSize)
                },
            rowSelection: {
                onChange: (selectedRowKeys, selectedRows) => this.onSelectChange(selectedRowKeys, selectedRows),
                onSelect: (record, selected, selectedRows) => {
                console.log(record, selected, selectedRows);
                },
                onSelectAll: (selected, selectedRows, changeRows) => {
                console.log(selected, selectedRows, changeRows);
            },
            }
    }
  },
  created:function(){
    this.getDeviceList()
  },
  methods: {
    onSelectChange (selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys
    },
    getDeviceList(){
      let userId = "";
      let tempUrl = window.location.href;
      let arr = tempUrl.split('#');
      this.pagination.current = this.pagination.current?this.pagination.current:1;
                let url =  "/ac-energy/DR/userDevice?userId=" + arr[1];
                let vm = this;
                this.axios.get(url).then(response => {
                    vm.result = response.data.result
                })
    },
    // onSelectChange(selectedRowKeys, selectedRows){
    //         console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    //         for(let i = 0; i < selectedRows.length; i++){
    //           this.selectList.push(selectedRows[i].sn)
    //         }
    //     },
     onSelectChange(selectedRowKeys, selectedRows){
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            this.selectArray.splice(0,this.selectArray.length);
            for(let i = 0; i<selectedRows.length;i++){
                this.selectArray[i] = selectedRows[i]
                console.log('selectArray',this.selectArray)
            }
            
            
        },
     addDevice(){
            
            var vm = this;
            vm.selectList = "";
            if(vm.selectArray.length == 1){
                vm.selectList = vm.selectArray[0].sn
            }
            else if(vm.selectArray.length == 0){
                vm.$message.error('请选择设备');
            }
            else{
                for(let i = 0, k= vm.selectArray.length;i < vm.selectArray.length -1 ; i++){
                        vm.selectList = vm.selectList + vm.selectArray[i].sn + ',';
                }
                vm.selectList = vm.selectList + vm.selectArray[vm.selectArray.length -1].sn   
            }
            let url = "/ac-energy/DR/active/confirm?sns=" + vm.selectList;
            //values.sns = vm.selectList;
            if(vm.selectArray.length >= 1){
              this.axios.post(url).then(response => {
              console.log(response.data);
              
              if (response.data.errCode == "0") {
                  vm.$message.success('加入成功');
                  vm.visible = true;
                  vm.getDeviceList();
                  
              } else {
                  vm.$message.error(response.data.errMsg);
              }
              });
            }
            
                  
                 
        },
      handleOk(){
        this.visible = false;
        window.opener = null;
        window.open("about:blank", "_top").close()
      }
  },
}
</script>